import { render } from "./DjAccountReviewTab.vue?vue&type=template&id=59c85ed8&scoped=true"
import script from "./DjAccountReviewTab.vue?vue&type=script&lang=js"
export * from "./DjAccountReviewTab.vue?vue&type=script&lang=js"

import "./DjAccountReviewTab.vue?vue&type=style&index=0&id=59c85ed8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59c85ed8"

export default script